import { render, staticRenderFns } from "./LProjectConfigurationChanges.vue?vue&type=template&id=4a65ddce&scoped=true&"
import script from "./LProjectConfigurationChanges.vue?vue&type=script&lang=js&"
export * from "./LProjectConfigurationChanges.vue?vue&type=script&lang=js&"
import style0 from "./LProjectConfigurationChanges.vue?vue&type=style&index=0&id=4a65ddce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a65ddce",
  null
  
)

export default component.exports